import { useState } from "react";
import { AdminPageLayout, AdminPageHeader } from "../../common/AdminPageLayout";
import { ADMIN_PAGE_META } from "../../common/adminPageMeta";
import PackageBookings from "./package/PackageBookings";
import EventBookings from "./event/EventBookings";
import AttractionBookings from "./attraction/AttractionBookings";
import ActivityBookings from "./activity/ActivityBookings";
import RentalBookings from "./rental/RentalBookings";

const Bookings = () => {
  const [activeTab, setActiveTab] = useState("packages");

  const renderTabContent = () => {
    switch (activeTab) {
      case "packages":
        return <PackageBookings />;
      case "events":
        return <EventBookings />;
      case "attractions":
        return <AttractionBookings />;
      case "activities":
        return <ActivityBookings />;
      case "rentals":
        return <RentalBookings />;
      default:
        return <PackageBookings />;
    }
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader
        title={ADMIN_PAGE_META.bookings.title}
        subtitle={ADMIN_PAGE_META.bookings.subtitle}
      />

      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab("packages")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "packages"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Package Bookings
            </button>
            <button
              onClick={() => setActiveTab("events")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "events"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Event Bookings
            </button>
            <button
              onClick={() => setActiveTab("attractions")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "attractions"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Attraction Bookings
            </button>
            <button
              onClick={() => setActiveTab("activities")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "activities"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Activity Bookings
            </button>
            <button
              onClick={() => setActiveTab("rentals")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "rentals"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Rental Bookings
            </button>
          </nav>
        </div>
      </div>

      {renderTabContent()}
    </AdminPageLayout>
  );
};

export default Bookings;
